/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      NO_HIRED_PRODUCTS_TO_BUY: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Ir a mis productos',
              link: URLS.MY_PRODUCTS,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'No es posible generar el pedido',
          msg: [
            'Tras revisar tus datos no cumples las condiciones necesarias para contratar el bono de llamadas, es necesario que tengas contratado miMovistar Base o miMovistar Max, tener todas las líneas móviles activas y no haberlo contratado previamente.',
            'Puedes revisar tu configuración en tu área privada',
          ],
          errorName: 'cliente sin tarifas moviles',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
